import { gridSize } from '@atlassian/jira-common-styles/src';

export const issueViewBottomPadding = 4 * gridSize;
export const fullPageIssueWrapperMarginTop = gridSize * 3;

export const gridPaddingOverrideSelectorName = 'jira-issue-view-issue-page-grid-padding-override';
export const GRID_PADDING_OVERRIDE_COMPONENT_SELECTOR = `[data-component-selector="${gridPaddingOverrideSelectorName}"]`;
